import React from 'react';
import 'components/CookieBanner/styles.css';
import CookieConsent from 'react-cookie-consent';
import { useTranslation } from 'react-i18next';
import theme from 'theme';
import { rem } from 'polished';

const CookieBanner = () => {
  const { t } = useTranslation();
  const { colors, fontWeights } = theme;
  const DAYS_TO_EXPIRE_COOKIES = 30;

  return (
    <CookieConsent
      location="bottom"
      buttonText={t('home.cookies_banner.accept')}
      enableDeclineButton
      declineButtonText={t('home.cookies_banner.reject')}
      buttonStyle={{
        backgroundColor: colors.primary,
        border: `1px solid ${colors.primary}`,
        color: colors.white,
        padding: '12px 24px 12px 24px',
        margin: 0,
        marginRight: '22px',
        borderRadius: '4px',
        fontWeight: fontWeights.bold,
      }}
      declineButtonStyle={{
        backgroundColor: colors.secondary,
        border: `1px solid ${colors.primary}`,
        color: colors.primary,
        padding: '12px 24px 12px 24px',
        marginLeft: 0,
        marginRight: '22px',
        borderRadius: '4px',
        fontWeight: fontWeights.bold,
      }}
      style={{
        background: colors.secondary,
        boxShadow: '0px 3px 16px rgba(0, 0, 0, 0.15)',
        color: colors.primary,
        fontWeight: fontWeights.semibold,
        fontSize: rem('16px'),
        lineHeight: '24px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      contentStyle={{
        margin: 0,
        opacity: 0.7,
        color: colors.tertiary,
      }}
      containerClasses="cookieContainerClass"
      expires={DAYS_TO_EXPIRE_COOKIES}
    >
      {t('home.cookies_banner.body')}
    </CookieConsent>
  );
};

export default CookieBanner;
